<template>
  <modal-template
    ref="modal"
    :title="title"
    type-modal="feed_filter_modal"
  >
    <div class="modal-content__main">
      <d-form>

        <d-form-row>
          <!-- Filter Name -->
          <d-col md="12" class="form-group">
            <label>Nome do filtro</label>
            <d-input v-model="model.name" />
          </d-col>
        </d-form-row>

        <d-form-row>
          <!-- Users -->
          <d-col md="6" class="form-group mb-0">
            <label>Usuarios</label>
            <list-items :items.sync="model.users" type="user" placeholder="Adicione um novo usuario"/>
          </d-col>
          <!-- Hastags -->
          <d-col md="6" class="form-group mb-0">
            <label>Hashtags</label>
            <list-items :items.sync="model.hashtags" type="hashtag" placeholder="Adicione uma nova hashtag" prepend="#"/>
          </d-col>
        </d-form-row>

      </d-form>
    </div>

    <div slot="actions" class="modal-content__control w-100" >
      <d-button
        type="button"
        @click="confirmDeleteRow()"
        class="btn btn-sm btn-danger float-left"
      >Delete</d-button>
      <d-button
        type="button"
        @click="save()"
        class="btn btn-sm btn-primary float-right"
      >Salvar</d-button>
    </div>
    <confirmation-modal
      :cancel="closeConfirm"
      :confirm="deleteFilter"
      title="Confrimação de exclusão"
      message="Tem certeza que deseja excluir este filtro?"/>
  </modal-template>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import FeedService from '_services/rest/modules/feed';
import ModalTemplate from '_shared/Modal.vue';
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import ListItems from './ListItems.vue';
import { _OPEN_FILTER_MODAL_, FILTER_MODEL, _EDIT_FILTER_ } from '../FeedModel';

export default {
  name: 'feed-filter-modal',
  components: {
    ListItems,
    ModalTemplate,
    ConfirmationModal,
  },
  props: {
    title: {
      type: String,
      default: 'Novo filtro',
    },
  },
  data() {
    return {
      loading: false,
      model: { ...FILTER_MODEL },
    };
  },
  computed: {
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
      'getFilterList',
    ]),
    close() {
      this.getFilterList();
      this.setToggle({ type: 'feed_filter_modal', bool: false });
    },
    closeConfirm() {
      this.setToggle({ type: 'confirm_modal', bool: false });
    },
    confirmDeleteRow() {
      this.setToggle({ type: 'confirm_modal', bool: true });
    },
    deleteFilter() {
      FeedService.deleteFilter(this.model.id)
        .then(() => {
          this.activeAlert({ message: 'Filtro deletado com sucesso', theme: 'success' });
          this.close();
          this.closeConfirm();
        });
    },
    save() {
      this.model.items = [...this.model.users, ...this.model.hashtags];
      FeedService.saveFilter(this.model)
        .then(response => {
          Events.$emit(_EDIT_FILTER_, response.data);
          this.activeAlert({ message: 'Filtro salvo com sucesso', theme: 'success' });
          this.close();
        });
    },
  },
  mounted() {
    Events.$on(_OPEN_FILTER_MODAL_, filter => {
      this.model = { ...FILTER_MODEL, ...filter };
    });
  },
};
</script>

<style lang="scss" scoped>

</style>
